/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Productcopyid3Inputs */

const en__field_productcopyid3 = /** @type {(inputs: _Field_Productcopyid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Copy ID`)
};

const de__field_productcopyid3 = /** @type {(inputs: _Field_Productcopyid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin Kopie ID`)
};

/**
* | output |
* | --- |
* | "Product Copy ID" |
*
* @param {_Field_Productcopyid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_productcopyid3 = /** @type {((inputs?: _Field_Productcopyid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Productcopyid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_productcopyid3(inputs)
	return de__field_productcopyid3(inputs)
});
export { _field_productcopyid3 as "_field_productCopyID" }